// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the checkbox row */

/* Description text above or near the checkbox */
.CheckBox_checkbox_description__g1qtU {
  font-size: 14px;
  color: #333;
}

/* Row for checkbox and label */
.CheckBox_checkbox_row__SBnYg {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #555;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/CheckBox/CheckBox.module.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC,gDAAgD;AAChD;EACE,eAAe;EACf,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* Container for the checkbox row */\n\n/* Description text above or near the checkbox */\n.checkbox_description {\n  font-size: 14px;\n  color: #333;\n}\n\n/* Row for checkbox and label */\n.checkbox_row {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #555;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox_description": `CheckBox_checkbox_description__g1qtU`,
	"checkbox_row": `CheckBox_checkbox_row__SBnYg`
};
export default ___CSS_LOADER_EXPORT___;
